export default {
  buttons: {
    apply: "Använd",
    cancel: "AVBRYT",
    dismiss: "Stäng",
    minimize: "minimera",
    unminimize: "ta bort minimering",
    add_waypoint: "lägg till en destination",
    navigate: "Navigera",
    send_to_phone: "skicka till mobilen"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "mi"
    }
  },
  send_to_phone: {
    title: "skicka till mobilen",
    copy_link: {
    header: "Kopiera länken för att dela",
    button: "Kopiera länken"
    },
    qr_code_header: "Scanna QR-koden med mobilen",
    mail: {
    link: "Skicka via e-post",
    header: "E-post",
      subject: "Shell {destination}",
      body: "{url}"
    }
  },
  search: {
    title: "Sök",
    placeholder: "Ange en plats",
    enter_location: "Ange en plats",
    recent_searches: "Senaste sökningar",
    suggestions: "Förslag",
    geolocation: "Använd min plats",
    help: {
      inactive: "Sök",
      clear: "Rensa"
    }
  },
  filters: {
    title: "Filter",
    more: "Fler filter",
    less: "Färre filter",
    group: {
      more: "Fler filter",
      less: "Stäng"
    },
    amenities: {
      title: "Service & Tjänster"
    },
    fuels: {
      title: "Drivmedelstyper"
    },
    open_statuses: {
      title: "Öppettider"
    }
  },
  directions: {
    title: "Hitta hit",
    help: {
      add_waypoint: "Via",
      reverse: "Omvänd färdväg",
      sort_waypoint: "Drag för att ändra ordning",
      remove: "Tag bort"
    },
    placeholder: {
      origin: "Från",
      destination: "Ange en plats",
      waypoint: "Ange en plats"
    },
    route: {
      title: "Alternativ färdväg",
      title_avoid: "Undvik",
      avoid_tolls: "Undvik vägar med tullavgifter",
      avoid_highways: "Undvik motorvägar",
      avoid_ferries: "Undvik färjor",
      title_corridor: "Avstånd till närmaste station"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# Vecka} other {# Veckor}}
{days, plural, =0 {} =1 {# dag} other {# dagar}}
{hours, plural, =0 {} =1 {# Timme} other {# Timmar}}
{minutes, plural, =0 {} =1 {# min.} other {# min.}}
`,
    button: "Sök",
    error: "Ett fel uppstod, vänligen försök igen"
  },
  action_panel: {
    back_to_results: "Tillbaka"
  },
  locations: {
    title: "platser",
    closed_temporarily: "Tillfälligt stängd",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} från {place}",
    description: "{visible, select, true {Göm} false {Visa} }"
  },
  open_now: {
    open_until: "Öppet nu: till {statusChangeTime, date, dateFormat}",
    open_24_hours: "Tanka dygnet runt",
    closed_until: "Stängt nu: öppnar igen {statusChangeTime, date, dateFormat}"
  },
  info_window: {
    back_to_results: "Tillbaka",
    title: "Platsinformation",
    location_id: "Stationsnummer",
    website: "Läs mer",
    services: "Service & Tjänster",
    nearby: "Närliggande",
    directions: "Lägg till i färdvägsplaneraren",
    mobile: {
    telephone: "Tel:"
    },
    opening_hours: {
      title: "Öppettider",
      mon: "Mån",
      tue: "Tis",
      wed: "Ons",
      thu: "Tor",
      fri: "Fre",
      sat: "Lör",
      sun: "Sön",
      open_twentyfourhours: "Tanka dygnet runt",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Fuel and Pricing Available",
      not_available: "Drivmedel",
      price: "{price, number, fuelPrice}",
      disclaimer: "Det är priset på pumpen som gäller",
      last_updated_on: "Senast uppdaterad",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Hitta hit"
  },
  fuels: {
    auto_rv_propane: "Auto RV Propane",
    autogas_lpg: "Autogas LPG",
    cng: "Fordonsgas",
    diesel_fit: "Diesel Fit",
    fuelsave_98: "98 Blyfri",
    fuelsave_midgrade_gasoline: "Fuelsave Midgrade Gasoline",
    fuelsave_regular_diesel: "Fuelsave Regular Diesel",
    gtl: "GTL",
    hydrogen: "Hydrogen",
    lng: "LNG",
    low_octane_gasoline: "Low Octane gasoline",
    midgrade_gasoline: "95 Blyfri",
    premium_diesel: "Premium Diesel",
    premium_gasoline: "V-Power",
    shell_regular_diesel: "Diesel",
    super98: "Super98",
    super_premium_gasoline: "Super Premium Gasoline",
    truck_diesel: "Truck Diesel",
    unleaded_super: "Unleaded Super",
    kerosene: "Kerosene",
    shell_recharge: "Shell Recharge",
  },
  amenities: {
    air_and_water: "Luft och vatten",
    atm_in: "ATM-IN",
    atm_out: "ATM-OUT",
    atm: "Bankomat",
    austrian_highway_sticker: "Österrikiskt motorvägsklistermärke",
    baby_change_facilities: "Baby changing facilites",
    bakery_shop: "Bageri",
    bottled_gas: "BBQ Propane Cylinder Exchange",
    burger: "Snabbmat",
    cafe: "Café",
    carwash: "Biltvätt",
    children_play_area: "Childrens play area",
    childs_toilet: "Water Closet or Toilet - child",
    clubsmart_card: "Shell ClubSmart Card",
    coca_cola_freestyle: "Coca Cola Freestyle",
    conveyor_and_jet: "Conveyor and Jet",
    conveyor: "Conveyor",
    costa_express: "Costa Express",
    credit_card_american_express: "Kreditkort - American Express",
    credit_card_diners_club: "Kreditkort - Diners Club",
    credit_card_general: "Bank-och kreditkort",
    credit_card_mastercard: "Kreditkort - Mastercard",
    credit_card_visa: "Kreditkort - Visa",
    credit_card: "Bank- och kreditkort",
    czech_highway_sticker: "Tjeckiskt motorvägsklistermärke",
    deli2go: "deli2go",
    disability_assistance: "Disability Assistance",
    disabled_facilities: "Handikappanpassad",
    euroshell_card: "Shellkort",
    fleet_card_dkv: "Företagskort",
    fleet_card_eni: "Fleet Card - Eni",
    fleet_card_esso: "Fleet Card - Esso",
    fleet_card_general: "Företagskort",
    fleet_card_uta: "Fleet Card - UTA",
    food_offerings: "Snabbmat",
    fuel_card: "Drivmedelskort",
    full_service: "Bemannad",
    guarded_car_park: "Bevakad parkering",
    hgv_lane: "Supportnät",
    high_speed_diesel_pump: "Höghastihetspump för diesel",
    hot_food: "Varm mat",
    hungarian_highway_sticker: "Ungerskt motorvägsklistermärke",
    ido_ticket: "Ido Ticket",
    jet: "Jet wash",
    lottery: "Lottery",
    loyalty_cards: "Lojalitetskort",
    manual: "Manual",
    maut_terminal: "Toll Smart Card",
    mobile_airtime: "Bageri",
    mobile_loyalty: "Mobile Loyalty",
    mobile_payment: "Mobil betalning",
    money_transfer_services: "Hyrsläp",
    motorway_service: "Motorway Service",
    navigator_fleet_loyalty_discount: "Loyalty discount",
    oil_and_lubricants: "Olja och smörjmedel",
    others: "Andra",
    parking_lanes: "P-plats",
    partner_card: "Partnerkort",
    partner_loyalty_accepted: "Partner Loyalty Accepted",
    pay_at_pump: "Betala vid pumpen",
    pizza: "Snabbmat",
    prayer_room: "Prayer room",
    quick_lubes: "Quick-lube",
    restaurant: "Restaurang",
    rollover_and_jet: "Rollover and Jet",
    rollover: "Rollover",
    sandwich: "Snabbmat",
    sconti_bancoposta: "Sconti BancoPosta",
    selectshop: "Shop - Select",
    self_service: "Självbetjäning",
    service_bay: "Serviceplatser",
    shell_card: "Shellkort",
    shell_club_smart_extra_card: "Shell Club Smart Extra Card",
    shop: "Butik",
    shower: "Dusch",
    slovak_highway_sticker: "Slovakiskt motorvägsklistermärke",
    snack_food: "Snabbmat",
    standard_toilet: "Toalett",
    starbucks: "Starbucks",
    supermarket_fuel_discount: "Drivmedelsrabatt",
    telepass_premium: "Telepass Premium",
    tim_hortons: "Tim Hortons",
    toilet: "Toalett",
    truck_parking: "Lastbilsparkering",
    truckport: "Endast tung trafik",
    twenty_four_hour: "Tanka dygnet runt",
    twotheloo: "2theloo",
    tyre_service: "Tyre service",
    unmanned: "Obemannad",
    utility_payment_services: "Svanenmärkt biltvätt",
    vacuum: "Dammsugare",
    vehicle_identity_system: "Fordonsidentifikations system",
    waitrose: "Waitrose",
    wifi: "WiFi",
    pizza_hut_express: "Pizza Hut Express",
    budgens: "Budgens",
    deli_cafe: "Deli Cafe",
    amazon_locker: "Amazon Locker",
    deli_by_shell: "Deli By Shell",
    car_wash_mpay: "Car Wash MPay",
    pay_tm: "PayTM",
    adblue_truck: "AdBluepump",
    adblue_car: "AdBlue Pump Passenger Vehicles",
    adblue_pack: "AdBlue Packed Product",
    migrolino: "Migrolino",
    spar_express: "Spar Express"
  },
  open_statuses: {
    open_now: "Öppet nu"
  },
  settings: {
    title: "Inställningar",
    tooltip: "Inställningar",
    traffic: "Trafik",
    distance_units: {
      title: "Avstånd",
      km: "Kilometer",
      miles: "Engelska mil"
    },
    language: {
      title: "Språk",
      locales: {
        es_AR: "Spanska",
        en_AU: "Engelska",
        de_AT: "Tyska",
        fr_BE: "Franska",
        nl_BE: "Holländska",
        pt_BR: "Portugisiska",
        en_BG: "Engelska",
        bg_BG: "Bulgariska",
        fr_CA: "Franska",
        en_CA: "Engelska",
        cz_CZ: "Tjeckiska",
        da_DK: "Danska",
        fi_FI: "Finska",
        fr_FR: "Franska",
        de_DE: "Tyska",
        en_HK: "Engelska",
        zh_HK: "Kinesiska (Mandarin)",
        hu_HU: "Ungerska",
        en_IN: "Engelska",
        en_ID: "Engelska",
        id_ID: "Indonesiska",
        it_IT: "Italienska",
        lv_LV: "Lettiska",
        ru_LV: "Ryska",
        lt_LT: "Litauiska",
        fr_LU: "Franska",
        en_LU: "Engelska",
        en_MY: "Engelska",
        en_MO: "Engelska",
        zh_MO: "Kinesiska (Mandarin)",
        es_MX: "Spanska",
        nl_NL: "Holländska",
        nb_NO: "Norska (Bokmål)",
        en_OM: "Engelska",
        ar_OM: "Arabiska",
        en_PK: "Engelska",
        ur_PK: "Urdu",
        en_PH: "Engelska",
        pl_PL: "Polska",
        es_PR: "Spanska",
        ro_RO: "Rumänska",
        ru_RU: "Ryska",
        en_SG: "Engelska",
        sk_SK: "Slovakiska",
        sl_SI: "Slovenska",
        en_ZA: "Engelska",
        sv_SE: "Svenska",
        fr_CH: "Franska",
        de_CH: "Tyska",
        th_TH: "Thailändska",
        tr_TR: "Turkiska",
        uk_UA: "Ukrainska",
        en_GB: "Engelska",
        en_US: "Engelska",
      }
    }
  },
  geolocation: {
    tooltip: "Använd min plats"
  }
}
